import axios from 'axios';
import keycloak from '../keycloak';
import {config} from "../config/config";

// Create axios instance
const api = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    'Content-type': 'application/json'
  }
});

api.interceptors.request.use(function (config) {
  let instanceId = null

  const requiresInstance =
    config?.url?.includes('groupmanagement') ||
    config?.url?.includes('instance/assigned/user/list') ||
    config?.url?.includes('instance/assigned/dataset/list') ||
    config?.url?.includes('instance/assigned/area/tree') ||
    config?.url?.includes('instance/roles/list')
    || config?.url?.includes('instance/context')
    || config?.url?.includes('entityTag/instance-hierarchy')
    || config?.url?.includes('instance/assigned/complextags/list');
  // console.log(config.url)
  // console.log(requiresInstance)
  if (requiresInstance) {
    const rawCurrentInstance = localStorage.getItem('currentInstanceContext')
    instanceId = rawCurrentInstance ? JSON.parse(rawCurrentInstance) : null
  }
  config.headers = {

    ...(requiresInstance && instanceId?.selectedInstance?.identifier && {
      'X-Instance-ID': instanceId?.selectedInstance?.identifier
    }),
    Authorization: `Bearer ${keycloak.token}`,
  };
  return config;
});

export default api;
